import DataFetcher from "./DataFetcher";
import IDataFetcher from "./IDataFetcher";

const dataFetcher: IDataFetcher = new DataFetcher();
export default dataFetcher;
